import { useState } from "react";

export default function DashboardOverview({
  projects,
  degerlendirmeBekleyenProjeler,
  projeBitmesineYakin,
  sonlandirmaGerekenProjeler,
  bitirmeBelgesiAlinacakProjeler,
  yazilimTescilGerekenProjeler,
  toplamPersonel,
  suresiGecenProjeler,
  kategoriChartData,
  teknoparkChartData,
  setActiveFilter,
  setActiveTab,
  setCurrentPage,
  setDateFilter,
  setShowNewProjectModal,
  setSelectedProject,
  setEditProject,
  getProjectStatusBadge,
  cardHoverStyle,
  setCompanyFilter,
  activityLogs,
  recentFiles,
  themeMode = "light",
  isAdmin = false
}) {

  const [activityFilter, setActivityFilter] = useState("all");
  const isDark = themeMode === "dark";
  const colors = {
    sectionBg: isDark ? "#111827" : "#ffffff",
    sectionBorder: isDark ? "#263244" : "#e5e7eb",
    softSectionBg: isDark ? "#111827" : "#ffffff",
    itemBg: isDark ? "#1f2937" : "#f9fafb",
    itemBorder: isDark ? "#334155" : "#e5e7eb",
    text: isDark ? "#e5edf6" : "#111827",
    muted: isDark ? "#94a3b8" : "#6b7280",
    buttonBg: isDark ? "#1e3a4a" : "#eef6ff",
    buttonText: isDark ? "#dff7ff" : "#124254",
    shadow: isDark ? "0 10px 28px rgba(0,0,0,0.28)" : "0 8px 24px rgba(0,0,0,0.05)"
  };

  const sonOtuzGunAktiviteleri = (activityLogs || []).filter((log) => {
  if (!log.createdAt?.toDate) return false;

  const logDate = log.createdAt.toDate();
  const now = new Date();
  const diffDays =
    (now.getTime() - logDate.getTime()) / (1000 * 60 * 60 * 24);

  return diffDays <= 30;
    });

    const filtreliSonOtuzGunAktiviteleri = sonOtuzGunAktiviteleri
      .filter((log) => {
        if (activityFilter === "project") return log.action?.includes("PROJE");
        if (activityFilter === "file") return log.action?.includes("DOSYA");
        if (activityFilter === "user") return log.action?.includes("KULLANICI");
        if (activityFilter === "excel") return log.action?.includes("EXCEL");

        return true;
      })
      .slice(0, 8);

    const getLogLabel = (action) => {
      const labels = {
        PROJE_EKLENDI: "Proje Eklendi",
        PROJE_GUNCELLENDI: "Proje Güncellendi",
        PROJE_SILINDI: "Proje Silindi",
        PROJE_ARSIVLENDI: "Proje Arşivlendi",
        DOSYA_YUKLENDI: "Dosya Yüklendi",
        DOSYA_SILINDI: "Dosya Silindi",
        EXCEL_YUKLENDI: "Excel Yüklendi",
        KULLANICI_OLUSTURULDU: "Kullanıcı Oluşturuldu",
        KULLANICI_SILINDI: "Kullanıcı Silindi",
        KULLANICI_GUNCELLENDI: "Kullanıcı Güncellendi",
      };

      return labels[action] || action || "İşlem";
    };

    const getLogIcon = (action) => {
      if (action?.includes("DOSYA")) return "📄";
      if (action?.includes("PROJE")) return "📁";
      if (action?.includes("KULLANICI")) return "👤";
      if (action?.includes("EXCEL")) return "📊";
      return "📝";
    };

    const formatLogDate = (createdAt) => {
      if (!createdAt?.toDate) return "-";
      return createdAt.toDate().toLocaleString("tr-TR");
    };

    const getLogColor = (action) => {
      if (action?.includes("DOSYA")) {
        return {
          border: "#16a34a",
          background: "#f0fdf4"
        };
      }

      if (action?.includes("PROJE")) {
        return {
          border: "#2563eb",
          background: "#eff6ff"
        };
      }

      if (action?.includes("KULLANICI")) {
        return {
          border: "#9333ea",
          background: "#faf5ff"
        };
      }

      if (action?.includes("EXCEL")) {
        return {
          border: "#ea580c",
          background: "#fff7ed"
        };
      }

      return {
        border: "#64748b",
        background: "#f8fafc"
      };
    };

    // Helper function to determine file style based on file type/name
    const getFileStyle = (file) => {
      const fileName = String(file?.name || "").toLowerCase();
      const fileType = String(file?.type || file?.mimeType || "").toLowerCase();

      if (fileName.endsWith(".pdf") || fileType.includes("pdf")) {
        return {
          icon: "📕",
          border: "#dc2626",
          background: "#fef2f2"
        };
      }

      if (
        fileName.endsWith(".xlsx") ||
        fileName.endsWith(".xls") ||
        fileType.includes("spreadsheet") ||
        fileType.includes("excel")
      ) {
        return {
          icon: "📗",
          border: "#16a34a",
          background: "#f0fdf4"
        };
      }

      if (
        fileName.endsWith(".doc") ||
        fileName.endsWith(".docx") ||
        fileType.includes("word")
      ) {
        return {
          icon: "📘",
          border: "#2563eb",
          background: "#eff6ff"
        };
      }

      if (
        fileName.endsWith(".jpg") ||
        fileName.endsWith(".jpeg") ||
        fileName.endsWith(".png") ||
        fileType.includes("image")
      ) {
        return {
          icon: "🖼️",
          border: "#9333ea",
          background: "#faf5ff"
        };
      }

      return {
        icon: "📎",
        border: "#64748b",
        background: "#f8fafc"
      };
    };

    // Teknopark ve Kategori chart yardımcıları
    const maxTeknoparkProjeSayisi = Math.max(
      ...((teknoparkChartData || []).map((item) => item.projeSayisi || 0)),
      1
    );

    const toplamKategoriProjeSayisi = (kategoriChartData || []).reduce(
      (total, item) => total + Number(item.value || 0),
      0
    );

        const hizliIslemler = [
          {
            title: "Yeni Proje",
            description: "Yeni proje kaydı oluştur",
            icon: "➕",
            action: () => {
              if (typeof setShowNewProjectModal === "function") {
                setShowNewProjectModal(true);
              }
            }
          },
          {
            title: "Tüm Projeler",
            description: "Proje listesini aç",
            icon: "📋",
            action: () => {
              setActiveFilter("all");
              setDateFilter("all");
              setActiveTab("projects");
              setCurrentPage(1);
            }
          },
          {
            title: "Firmalar",
            description: "Firma bazlı takip ekranı",
            icon: "🏢",
            action: () => {
              setCompanyFilter("all");
              setActiveTab("companies");
            }
          },
          {
            title: "Dosya Yönetimi",
            description: "Yüklenen belgeleri görüntüle",
            icon: "📁",
            action: () => setActiveTab("files")
          },
          ...(isAdmin ? [{
            title: "Sistem Hareketleri",
            description: "İşlem geçmişini incele",
            icon: "📜",
            action: () => setActiveTab("logs")
          }] : [])
        ];

        const renderProjectSection = ({
          title,
          projects: sectionProjects,
          filter,
          emptyText,
          borderColor = "#e5e7eb",
          background = "#fff"
        }) => (
          <div
            style={{
              border: `1px solid ${isDark ? colors.sectionBorder : borderColor}`,
              padding: 24,
              borderRadius: 18,
              marginBottom: 24,
              background: isDark ? colors.softSectionBg : background,
              boxShadow: colors.shadow
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
                marginBottom: 10
              }}
            >
              <h2 style={{ margin: 0, fontSize: 24, fontWeight: 800, color: colors.text }}>
                {title}
              </h2>

              <button
                type="button"
                onClick={() => {
                  setActiveFilter(filter);
                  setActiveTab("projects");
                  setCurrentPage(1);
                }}
                style={{
                  border: "none",
                  background: colors.buttonBg,
                  color: colors.buttonText,
                  padding: "8px 12px",
                  borderRadius: 10,
                  fontWeight: 800,
                  cursor: "pointer"
                }}
              >
                Tümünü Gör →
              </button>
            </div>

            <p style={{ color: colors.muted, fontSize: 15, marginTop: 0 }}>
              Toplam: <strong>{sectionProjects.length}</strong>
            </p>

            {sectionProjects.length === 0 ? (
              <p style={{ color: colors.muted, marginBottom: 0 }}>{emptyText}</p>
            ) : (
              <div style={{ maxHeight: 400, overflowY: "auto", marginTop: 12, paddingRight: 8 }}>
                <ul style={{ padding: 0, margin: 0, display: "grid", gap: 10 }}>
                  {sectionProjects.slice(0, 50).map((project) => {
                    const badge = getProjectStatusBadge(project);

                    return (
                      <li
                        key={project.id}
                        onClick={() => {
                          setSelectedProject(project);
                          setEditProject(project);
                        }}
                        style={{
                          cursor: "pointer",
                          padding: "12px 14px",
                          borderRadius: 14,
                          background: colors.itemBg,
                          border: `1px solid ${colors.itemBorder}`,
                          listStyle: "none"
                        }}
                      >
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "minmax(0, 1fr) auto",
                            gap: 12,
                            alignItems: "center"
                          }}
                        >
                          <div style={{ minWidth: 0 }}>
                            <div
                              style={{
                                color: colors.text,
                                fontSize: 14,
                                lineHeight: 1.35
                              }}
                            >
                              <strong>{project.firmaAdi || "-"}</strong>
                              <span style={{ color: isDark ? "#cbd5e1" : "#374151" }}> - {project.projeAdi || "-"}</span>
                            </div>

                            <div
                              style={{
                                fontSize: 12,
                                color: colors.muted,
                                marginTop: 5,
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 8
                              }}
                            >
                              <span>{project.teknoparkAdi || "-"}</span>
                              <span>STB: {project.projeStbKodu || "-"}</span>
                            </div>
                          </div>

                          <span
                            style={{
                              height: "fit-content",
                              padding: "5px 10px",
                              borderRadius: 999,
                              fontSize: 12,
                              fontWeight: 800,
                              background: badge.background,
                              color: badge.color,
                              whiteSpace: "nowrap"
                            }}
                          >
                            {badge.text}
                          </span>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        );

    return (
      <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                gap: 20,
                marginBottom: 32
              }}
            >
              {[
                {
                  title: "Toplam Proje",
                  value: projects.length,
                  filter: "all",
                  bg: "#e0f2fe",
                  border: "#38bdf8",
                  icon: "📁"
                },
                {
                  title: "Yaklaşan",
                  value: projeBitmesineYakin.length,
                  filter: "yaklasan",
                  bg: "#fef3c7",
                  border: "#f59e0b",
                  icon: "⏳"
                },
                {
                  title: "Sonlandırılacak",
                  value: sonlandirmaGerekenProjeler.length,
                  filter: "sonlandirma",
                  bg: "#fee2e2",
                  border: "#ef4444",
                  icon: "⚠️"
                },
                {
                  title: "Bitirme Belgesi",
                  value: bitirmeBelgesiAlinacakProjeler.length,
                  filter: "bitirme",
                  bg: "#fff7ed",
                  border: "#fb923c",
                  icon: "📄"
                },
                {
                  title: "Tescil Bekleyen",
                  value: yazilimTescilGerekenProjeler.length,
                  filter: "tescil",
                  bg: "#ede9fe",
                  border: "#8b5cf6",
                  icon: "🛡️"
                }
              ].map((card) => (
                <div
                  key={card.title}
                  onClick={() => {
                    setActiveFilter(card.filter);
                    setActiveTab("projects");
                    setCurrentPage(1);
                  }}
                  onMouseEnter={(e) => {
                    Object.assign(e.currentTarget.style, cardHoverStyle);
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "0 8px 24px rgba(0,0,0,0.08)";
                  }}
                  style={{
                    background: isDark ? colors.sectionBg : card.bg,
                    padding: 22,
                    borderRadius: 16,
                    borderLeft: `6px solid ${card.border}`,
                    borderTop: isDark ? `1px solid ${colors.sectionBorder}` : "none",
                    borderRight: isDark ? `1px solid ${colors.sectionBorder}` : "none",
                    borderBottom: isDark ? `1px solid ${colors.sectionBorder}` : "none",
                    cursor: "pointer",
                    transition: "0.2s ease",
                    boxShadow: isDark ? "0 10px 28px rgba(0,0,0,0.28)" : "0 8px 24px rgba(0,0,0,0.08)",
                    color: colors.text
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between"
                    }}
                  >
                    <div style={{ color: isDark ? "#cbd5e1" : "#555", fontWeight: 600 }}>
                      {card.title}
                    </div>

                    <div
                      style={{
                        width: 42,
                        height: 42,
                        borderRadius: 14,
                        background: isDark ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.65)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 22,
                        boxShadow: "0 6px 16px rgba(0,0,0,0.08)"
                      }}
                    >
                      {card.icon}
                    </div>
                  </div>

                  <div
                    style={{
                      fontSize: 36,
                      fontWeight: 800,
                      marginTop: 12
                    }}
                  >
                    {card.value}
                  </div>

                  <div
                    style={{
                      marginTop: 10,
                      fontSize: 13,
                      color: isDark ? "#94a3b8" : "#666"
                    }}
                  >
                    Listeyi görüntüle →
                  </div>
                </div>

              ))}

            </div>

              <div
                style={{
                  background: colors.sectionBg,
                  border: `1px solid ${colors.sectionBorder}`,
                  borderRadius: 18,
                  padding: 20,
                  boxShadow: colors.shadow,
                  marginBottom: 24
                }}
              >
                <h2 style={{ marginTop: 0, marginBottom: 16, color: isDark ? "#e5edf6" : "#124254" }}>
                  Hızlı İşlemler
                </h2>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
                    gap: 14
                  }}
                >
                  {hizliIslemler.map((item) => (
                    <button
                      key={item.title}
                      type="button"
                      onClick={item.action}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        border: `1px solid ${colors.itemBorder}`,
                        background: colors.itemBg,
                        borderRadius: 16,
                        padding: "15px 16px",
                        textAlign: "left",
                        cursor: "pointer",
                        boxShadow: isDark ? "0 8px 22px rgba(0,0,0,0.18)" : "0 6px 18px rgba(0,0,0,0.04)"
                      }}
                    >
                      <span
                        style={{
                          width: 42,
                          height: 42,
                          borderRadius: 14,
                          background: isDark ? "#172f3d" : "#eef6ff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 22,
                          flexShrink: 0
                        }}
                      >
                        {item.icon}
                      </span>

                      <span>
                        <strong
                          style={{
                            display: "block",
                            color: isDark ? "#e5edf6" : "#124254",
                            fontSize: 14,
                            marginBottom: 4
                          }}
                        >
                          {item.title}
                        </strong>

                        <span style={{ color: colors.muted, fontSize: 12, fontWeight: 700 }}>
                          {item.description}
                        </span>
                      </span>
                    </button>
                  ))}
                </div>
              </div>

            {renderProjectSection({
              title: "Değerlendirme Bekleyen Projeler",
              projects: degerlendirmeBekleyenProjeler,
              filter: "db",
              emptyText: "Değerlendirme bekleyen proje bulunmuyor.",
              borderColor: "#e5e7eb",
              background: "#ffffff"
            })}

            {renderProjectSection({
              title: "Proje Bitmesine Yaklaşan Projeler",
              projects: projeBitmesineYakin,
              filter: "yaklasan",
              emptyText: "Yaklaşan proje yok.",
              borderColor: "#f4e2a7",
              background: "#fffbea"
            })}

            {renderProjectSection({
              title: "Proje Bitirme Belgesi Alınması Gereken Projeler",
              projects: bitirmeBelgesiAlinacakProjeler,
              filter: "bitirme",
              emptyText: "Bitirme belgesi alınması gereken proje bulunmuyor.",
              borderColor: "#f5e6c8",
              background: "#fffaf2"
            })}

            {renderProjectSection({
              title: "Proje Sonlandırması Yapılacak Projeler",
              projects: sonlandirmaGerekenProjeler,
              filter: "sonlandirma",
              emptyText: "Sonlandırılması gereken proje yok.",
              borderColor: "#f3caca",
              background: "#fff5f5"
            })}

            {renderProjectSection({
              title: "Yazılım Tescil Belgesi Gereken Projeler",
              projects: yazilimTescilGerekenProjeler,
              filter: "tescil",
              emptyText: "Tescil belgesi gereken proje yok.",
              borderColor: "#ddd6fe",
              background: "#f8f5ff"
            })}

            <div
              style={{
                background: colors.sectionBg,
                border: `1px solid ${colors.sectionBorder}`,
                padding: 24,
                borderRadius: 18,
                marginTop: 24,
                boxShadow: colors.shadow
              }}
              >
              <h2 style={{ marginTop: 0, color: colors.text }}>Son Yüklenen Dosyalar</h2>

              <div style={{ display: "grid", gap: 10 }}>
                {(recentFiles || []).length === 0 ? (
                  <div style={{ color: colors.muted }}>Henüz dosya yüklenmemiş.</div>
                ) : (
                  (recentFiles || []).map((file, index) => {
                    const fileStyle = getFileStyle(file);

                    return (
                      <div
                        key={index}
                        style={{
                          padding: 14,
                          borderRadius: 12,
                          border: `1px solid ${fileStyle.border}`,
                          borderLeft: `5px solid ${fileStyle.border}`,
                          background: isDark ? colors.itemBg : fileStyle.background,
                          color: colors.text
                        }}
                      >
                        <strong>
                          {fileStyle.icon} {file.name}
                        </strong>

                        <div style={{ fontSize: 13, color: colors.muted, marginTop: 6 }}>
                          {file.firmaAdi} • {file.projeAdi}
                        </div>

                        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 4 }}>
                          {file.category || "Genel"} •{" "}
                          {file.uploadedAt
                            ? new Date(file.uploadedAt).toLocaleString("tr-TR")
                            : "-"}
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>

            {isAdmin && (
            <div
              style={{
                background: colors.sectionBg,
                border: `1px solid ${colors.sectionBorder}`,
                borderRadius: 18,
                padding: 20,
                boxShadow: colors.shadow,
                marginBottom: 24
              }}
              >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 12,
                  marginBottom: 16
                }}
              >
                <h2 style={{ margin: 0, color: isDark ? "#e5edf6" : "#124254" }}>
                  Son 30 Gün Sistem Hareketleri
                </h2>

                <button
                  type="button"
                  onClick={() => setActiveTab("logs")}
                  style={{
                    border: "none",
                    background: colors.buttonBg,
                    color: colors.buttonText,
                    padding: "8px 12px",
                    borderRadius: 10,
                    fontWeight: 800,
                    cursor: "pointer"
                  }}
                >
                  Tümünü Gör →
                </button>
              </div>

              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
                {[
                  { key: "all", label: `Tümü (${sonOtuzGunAktiviteleri.length})` },
                  { key: "project", label: `Projeler (${sonOtuzGunAktiviteleri.filter((log) => log.action?.includes("PROJE")).length})` },
                  { key: "file", label: `Dosyalar (${sonOtuzGunAktiviteleri.filter((log) => log.action?.includes("DOSYA")).length})` },
                  { key: "user", label: `Kullanıcılar (${sonOtuzGunAktiviteleri.filter((log) => log.action?.includes("KULLANICI")).length})` },
                  { key: "excel", label: `Excel (${sonOtuzGunAktiviteleri.filter((log) => log.action?.includes("EXCEL")).length})` }
                ].map((filter) => (
                  <button
                    key={filter.key}
                    type="button"
                    onClick={() => setActivityFilter(filter.key)}
                    style={{
                      border: `1px solid ${colors.itemBorder}`,
                      background: activityFilter === filter.key ? "#124254" : colors.itemBg,
                      color: activityFilter === filter.key ? "#fff" : colors.buttonText,
                      padding: "8px 11px",
                      borderRadius: 999,
                      fontSize: 13,
                      fontWeight: 800,
                      cursor: "pointer"
                    }}
                  >
                    {filter.label}
                  </button>
                ))}
              </div>

              {filtreliSonOtuzGunAktiviteleri.length === 0 ? (
                <div style={{ color: colors.muted }}>
                  Son 30 günde kayıt bulunamadı.
                </div>
              ) : (
                <div style={{ display: "grid", gap: 12 }}>
                  {filtreliSonOtuzGunAktiviteleri.map((log) => {
                    const style = getLogColor(log.action);

                    return (
                      <div
                        key={log.id}
                        style={{
                          padding: 14,
                          borderRadius: 14,
                          background: isDark ? colors.itemBg : style.background,
                          color: colors.text,
                          border: isDark ? `1px solid ${colors.itemBorder}` : "none",
                          borderLeft: `5px solid ${style.border}`
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 12
                          }}
                        >
                          <strong>
                            {getLogIcon(log.action)} {getLogLabel(log.action)}
                          </strong>

                          <span
                            style={{
                              fontSize: 12,
                              color: colors.muted
                            }}
                          >
                            {formatLogDate(log.createdAt)}
                          </span>
                        </div>

                        <div
                          style={{
                            marginTop: 6,
                            color: isDark ? "#cbd5e1" : "#334155"
                          }}
                        >
                          {log.detail}
                        </div>

                        <div
                          style={{
                            marginTop: 4,
                            fontSize: 12,
                            color: colors.muted
                          }}
                        >
                          {log.userEmail}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            )}

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                gap: 20,
                marginBottom: 24
              }}
            >
              <div
                style={{
                  background: colors.sectionBg,
                  border: `1px solid ${colors.sectionBorder}`,
                  borderRadius: 18,
                  padding: 20,
                  boxShadow: colors.shadow
                }}
              >
                <h2 style={{ marginTop: 0, marginBottom: 16, color: isDark ? "#e5edf6" : "#124254" }}>
                  Teknopark Dağılımı
                </h2>
                <div style={{ display: "grid", gap: 12 }}>
                  {(teknoparkChartData || []).slice(0, 8).map((item) => {
                    const width = Math.max(
                      Math.round(((item.projeSayisi || 0) / maxTeknoparkProjeSayisi) * 100),
                      4
                    );

                    return (
                      <div key={item.name}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 10,
                            fontSize: 13,
                            fontWeight: 800,
                            color: isDark ? "#cbd5e1" : "#124254",
                            marginBottom: 5
                          }}
                        >
                          <span>{item.name}</span>
                          <span>{item.projeSayisi}</span>
                        </div>

                        <div
                          style={{
                            height: 10,
                            borderRadius: 999,
                            background: isDark ? "#263244" : "#e5e7eb",
                            overflow: "hidden"
                          }}
                        >
                          <div
                            style={{
                              width: `${width}%`,
                              height: "100%",
                              background: isDark ? "#5eb8b2" : "#124254",
                              borderRadius: 999
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div
                style={{
                  background: colors.sectionBg,
                  border: `1px solid ${colors.sectionBorder}`,
                  borderRadius: 18,
                  padding: 20,
                  boxShadow: colors.shadow
                }}
              >
                <h2 style={{ marginTop: 0, marginBottom: 16, color: isDark ? "#e5edf6" : "#124254" }}>
                  Proje Kategori Dağılımı
                </h2>
                <div style={{ display: "grid", gap: 12 }}>
                  {(kategoriChartData || []).map((item) => {
                    const percent = toplamKategoriProjeSayisi
                      ? Math.round((Number(item.value || 0) / toplamKategoriProjeSayisi) * 100)
                      : 0;

                    return (
                      <div key={item.name}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 10,
                            fontSize: 13,
                            fontWeight: 800,
                            color: isDark ? "#cbd5e1" : "#124254",
                            marginBottom: 5
                          }}
                        >
                          <span>{item.name}</span>
                          <span>{item.value} proje • %{percent}</span>
                        </div>

                        <div
                          style={{
                            height: 10,
                            borderRadius: 999,
                            background: isDark ? "#263244" : "#e5e7eb",
                            overflow: "hidden"
                          }}
                        >
                          <div
                            style={{
                              width: `${Math.max(percent, item.value ? 4 : 0)}%`,
                              height: "100%",
                              background:
                                item.name === "Yazılım"
                                  ? "#5eb8b2"
                                  : item.name === "Ar-Ge"
                                  ? (isDark ? "#60a5fa" : "#124254")
                                  : "#94a3b8",
                              borderRadius: 999
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </>
    );
  }
